document.addEventListener('alpine:init', () => {
    Alpine.data('stockValueChart', (values, labels, ref, type, valueType, currencySymbol, labelSuffix) => ({
        values: [],
        labels: [],
        type: type,
        valueType: [],
        labelSuffix: [],
        currencySymbol: currencySymbol,
        color: '#fff',
        ref: ref,
        chartInstance: null,
        init() {
            this.values = JSON.parse(values)
            this.labels = JSON.parse(labels)
            this.valueType = JSON.parse(valueType)
            this.labelSuffix = JSON.parse(labelSuffix)
            this.renderChart();
            Livewire.on('update-stock-chart', (data) => {
                if(data[0].ref == this.ref) {
                    this.values = JSON.parse(data[0].values);
                    this.labels = JSON.parse(data[0].labels);
                    this.renderChart();
                }
            })
        },
        renderChart() {
            if (this.chartInstance) {
                this.chartInstance.destroy();
            }

            const canvasElement = this.$refs[this.ref];
            if (canvasElement) {
                const ctx = canvasElement.getContext('2d');
                if (ctx) {

                    const tooltipCallback = (context) => {
                        let label = context.dataset.label || '';
                        const currentValue = parseFloat(context.raw);

                        if(label.length <= 0) {
                            label = context.label || '';
                        }

                        if (label) {
                            label += ': ';
                        }
                        let percentageString = '';

                        if (this.type === 'pie' || this.type === 'doughnut') {
                            const dataArray = this.values[0]?.data || [];
                            const total = dataArray.reduce((sum, value) => {
                                const numericValue = parseFloat(value);
                                return sum + (isNaN(numericValue) ? 0 : numericValue);
                            }, 0);

                            if (total > 0 && !isNaN(currentValue)) {
                                const percentage = ((currentValue / total) * 100).toFixed(2);
                                percentageString = ` (${percentage}%)`;
                            }
                        }

                        if (this.valueType[context.datasetIndex] === 'currency') {

                            const formattedNumber = (context.parsed.y || context.parsed).toLocaleString('nl-NL', {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2
                            });
                            const formattedValue = `${this.currencySymbol} ${formattedNumber}`;

                            label += formattedValue + percentageString;
                        } else {
                            label += context.raw;
                        }

                        if(this.labelSuffix[context.datasetIndex]) {
                            label += " " + this.labelSuffix[context.datasetIndex];
                        }

                        return label;
                    };

                    const graphConfig = {
                        type: this.type,
                        data: {
                            labels: this.labels,
                            datasets: this.values
                        },
                        options: {
                            responsive: true,
                            maintainAspectRatio: false,
                            animation: {
                                duration: 0
                            },
                            scales: {
                                y: {
                                    stacked: false,
                                    beginAtZero: true
                                },
                                x: {
                                    stacked: false
                                }
                            },
                            plugins: {
                                tooltip: {
                                    callbacks: {
                                        label: tooltipCallback,
                                    }
                                }
                            }
                        }
                    };

                    if (this.type === 'pie') {
                        graphConfig.options.plugins.legend = { display: false };
                        graphConfig.options.scales = { x: { display: false }, y: { display: false } };
                    }

                    this.chartInstance = new Chart(ctx, graphConfig);
                } else {
                    console.error('Could not get 2D context for canvas.');
                }
            } else {
                console.error('Canvas element with ref "' + this.ref + '" not found.');
            }
        }
    }));
});
